import { useState, useEffect } from 'react';
import Info from '../Info';
import BarChart from '../../charts/BarChart01';

// Import utilities
import { tailwindConfig } from '../../utils/Utils';

function DashboardCategoryCard({data, title, hint, label}) {

  const [ categories, setCategories ] = useState({})

  const options = {
    fontWeight: 500,
    fontFamily: 'Inter, sans-serif'
  };

  useEffect(() => {
    if(data!=null)
      setCategories(data)
  }, [data]);

  const chartData = {
    labels: categories.labels,
    datasets: [
      // Blue bars
      {
        label: label,
        data: categories.values,
        backgroundColor: tailwindConfig().theme.colors.pink[500],
        hoverBackgroundColor: tailwindConfig().theme.colors.pink[600],
        barPercentage: 0.66,
        categoryPercentage: 0.66,
      },
    ],
  };

  return (
    <div className="flex flex-col col-span-full sm:col-span-3 bg-white shadow-lg rounded-sm border border-gray-200 h-full">
      <header className="px-5 py-4 border-b border-gray-100 flex items-center">
        <h2 className="font-semibold text-gray-800">{title}</h2>
        <Info className="ml-2" containerClassName="min-w-80">
          <div className="text-sm">{hint}</div>
        </Info>
      </header>
      {/* Chart built with Chart.js 3 */}
      {/* Change the height attribute to adjust the chart height */}
      <BarChart data={chartData} width={595} height={250} />
    </div>
  );
}

export default DashboardCategoryCard;
